import { NoSymbolIcon } from '@heroicons/react/24/solid';
import React from 'react';

import { formatDuration } from '../../../../utils/dateUtils';
import { ProgressTooltip } from '../../../Check-In/components/ProgressTooltip';

import { TProgressData } from './types';

export function TimelineCell({
  progress,
  previousProgress,
  hasBlocker,
  type = 'ticket',
  label,
  freeLeft,
  freeRight,
}: TProgressData & {
  type?: 'ticket' | 'adhoc' | 'meeting';
  label?: string;
}): JSX.Element {
  if (type === 'adhoc') {
    // Show number of tasks (label or progress as fallback)
    return (
      <div
        className={`w-full h-full py-3 px-2 ${freeLeft ? 'pl-0' : 'pl-2'} ${
          freeRight ? 'pr-0' : 'pr-2'
        }`}
      >
        <div
          className={`h-7 ${freeLeft ? 'rounded-l-none' : 'rounded-l'} ${
            freeRight ? 'rounded-r-none' : 'rounded-r'
          } w-full bg-[#FFF7E6] flex items-center justify-center`}
        >
          <span className="text-xs text-[]text-gray-800 font-medium">
            {label ||
              (progress
                ? `${progress} ${progress === 1 ? 'Task' : 'Tasks'}`
                : '')}
          </span>
        </div>
      </div>
    );
  }
  if (type === 'meeting') {
    // Show duration (label or progress as fallback)
    return (
      <div className={`w-full h-full py-3 px-2 `}>
        <div className="h-7 rounded w-full bg-gray-100 flex items-center justify-center">
          <span className="text-xs text-gray-800 font-medium">
            {label || formatDuration(progress || 0)}
          </span>
        </div>
      </div>
    );
  }
  if (
    progress === null ||
    progress === undefined ||
    previousProgress === null
  ) {
    return <div className="h-full bg-gray-500" />;
  }

  let ticketTextColor = 'text-black';
  if (progress === 100) ticketTextColor = 'text-green-500';
  else if (progress < (previousProgress || 0)) ticketTextColor = 'text-red-500';

  const progressDiff = progress - (previousProgress || 0);

  return (
    <ProgressTooltip
      progressAchieved={progressDiff}
      previousProgress={previousProgress || 0}
      totalProgress={progress}
    >
      <div
        className={`w-full h-full py-3 px-2 ${freeLeft ? 'pl-0' : 'pl-2'} ${
          freeRight ? 'pr-0' : 'pr-2'
        }`}
      >
        <div
          className={`h-7 w-full flex items-center justify-center bg-[#EBF9FF] ${
            freeLeft ? 'rounded-l-none' : 'rounded-l'
          } ${freeRight ? 'rounded-r-none' : 'rounded-r'}`}
        >
          <div
            className={`px-2 text-xs font-medium h-full flex items-center justify-center gap-1 ${ticketTextColor}`}
          >
            <div className="flex items-center gap-1">
              <span>{progress}%</span>
              {hasBlocker && (
                <NoSymbolIcon className="h-4 w-4 text-red-500 bg-white rounded-full" />
              )}
            </div>
          </div>
        </div>
      </div>
    </ProgressTooltip>
  );
}
